import LinearStepper from "./LinearStepper";
import { useContext, useEffect } from "react";
import { useLocationRepository } from "../../api/repositories/LocationRepository";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { fromGenericBeToGenericFe } from "../../utils";
import { useRecoilState } from "recoil";
import { SelectElementModelBE, SelectElementModelFE } from "../../api/types/generic";
import { locationsAtom } from "../../state/locationsRecoil";
import { useLocationGroupRepository } from "../../api/repositories/LocationGroupRepository";
import { locationGroupsAtom } from "../../state/locationGroupsRecoil";
import { useTranslation } from "react-i18next";
import { Location, LocationModelFE } from "../../api/types/location";

type Props = {
  setFormDialog: Function;
  handleConfirmSave: Function;
  readonly: boolean;
};

const AlertCreation = ({ setFormDialog, handleConfirmSave, readonly }: Props) => {
  // Use Translation
  const { t } = useTranslation(["translation", "pricing"]);

  // // Use Context
  const { dispatchGlobalData, globalData: { user } } = useContext(GlobalContext);

  const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
    (el: SelectElementModelBE) => ({
      code: el.name,
      label: t("translation:legalEntities.".concat(el.name))
    })
  );

  //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
  const optionsFiltered = legalEntityOptions
    .filter(function(el) {
      return el.code !== "all";
    });

  // // Use Repository Hooks
  const { getLocationAllFiltered } = useLocationRepository();
  const { getLocationGroups } = useLocationGroupRepository();
  //
  // // Use Recoil
  const [, setLocations] = useRecoilState<SelectElementModelFE[]>(locationsAtom);
  const [, setLocationGroups] = useRecoilState<SelectElementModelFE[]>(locationGroupsAtom);
  //
  // // Use Query

  //
  const reloadLocations = async () => {
    try {
      let locations = await getLocationAllFiltered(optionsFiltered.flatMap((el) => el.code).join(","));
      if (locations) {
        const locationsFe: LocationModelFE[] = fromGenericBeToGenericFe<Location, LocationModelFE>(locations as Location[]).sort((a: LocationModelFE, b: LocationModelFE) => a.label.localeCompare(b.label));
        setLocations([{ code: 0, label: t("pricing:actions.selectAll") }, ...locationsFe]);

        const locationGroupsData: SelectElementModelBE[] = await getLocationGroups(optionsFiltered.flatMap((el) => el.code).join(","));
        const locationsGroups: SelectElementModelFE[] = fromGenericBeToGenericFe(locationGroupsData);
        setLocationGroups([{ code: 0, label: t("pricing:actions.selectAll") }, ...locationsGroups]);
      }
    } catch (e) {
    }
  };
  //
  useEffect(() => {
    reloadLocations();
  }, []);

  return (
    <LinearStepper
      setFormDialog={setFormDialog}
      handleConfirmSave={handleConfirmSave}
      readonly={readonly}
    />
  );
};

export default AlertCreation;
